import React from "react";
import PageHero from "../components/PageHero";
import { Home, Bus } from "lucide-react";

export default function ResidentialLifePage() {
  return (
    <div data-testid="residential-life-page">
      <PageHero
        path="residential-life.hero"
        kicker="Student Life"
        title="Residential Life"
        subtitle="Comfortable accommodation and easy transport so students feel at home while they train with us."
      />
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl p-7 shadow-sm border border-slate-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-12 w-12 rounded-xl bg-yellow-400/15 flex items-center justify-center">
                <Home className="h-6 w-6 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold text-[#0B2A6B]">Accommodation</h3>
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">
              Accommodation is available in the nearby housing area of IMT Manesar. Housing categories range from standard to
              luxury. Students can choose shared or single rooms, and those especially interested in luxurious accommodation may
              opt for air conditioning. Food is served at the accommodation. A separate women-only accommodation is also available.
              More information is provided at the time of joining.
            </p>
          </div>
          <div className="bg-white rounded-2xl p-7 shadow-sm border border-slate-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-12 w-12 rounded-xl bg-yellow-400/15 flex items-center justify-center">
                <Bus className="h-6 w-6 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold text-[#0B2A6B]">Transport</h3>
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">
              Manesar is well connected to Delhi through the Metro. Buses, shuttles and shared autos ply frequently between
              HUDA/IFFCO Chowk metro station and IMT Manesar. Those staying in Gurgaon, Rewari, Dharuhera and Neemrana find it
              convenient to travel daily. A bus shuttle for Kiki students is also available. More information is provided at the
              time of joining.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
